import { render, staticRenderFns } from "./feature-nonpromo-items.vue?vue&type=template&id=c559f504&scoped=true"
import script from "./feature-nonpromo-items.vue?vue&type=script&lang=js"
export * from "./feature-nonpromo-items.vue?vue&type=script&lang=js"
import style0 from "./feature-nonpromo-items.vue?vue&type=style&index=0&id=c559f504&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c559f504",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4220330617/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c559f504')) {
      api.createRecord('c559f504', component.options)
    } else {
      api.reload('c559f504', component.options)
    }
    module.hot.accept("./feature-nonpromo-items.vue?vue&type=template&id=c559f504&scoped=true", function () {
      api.rerender('c559f504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/features/feature-nonpromo-items.vue"
export default component.exports